/**
 * Generates an error message when a value is not a key of the provided record.
 * 
 * @param guardName - The name of the variable being guarded.
 * @param guard - The record containing valid keys.
 * @returns A formatted error message.
 */
export const notObjectKeyMessage = (guardName: string, guard: Record<any, any>): string => (
  `'${guardName}' must be one of '${Object.keys(guard).join(', ')}'`
)

/**
 * Throws an error if the provided key is not present in the given record.
 * 
 * @param guardName - The name of the variable being guarded.
 * @param guard - The record to check against.
 * @param guardObjectKey - The key to check for existence in the record.
 * @throws {Error} Throws an error if `Object.hasOwn(guard, guardObjectKey)` is false.
 */
export const throwNotObjectKey = (guardName: string, guard: Record<any, any>, guardObjectKey: string): void => {
  const hasKey = Object.hasOwn(guard, guardObjectKey);
  if (hasKey === false) {
    throw new Error(notObjectKeyMessage(guardName, guard));
  }
}